export default __webpack_public_path__ + "static/company-casa-e-video-8fdc59493f38722f0ed35d2cc068ffe2.svg";